import * as sidebarActionTypes from '../../Store/Sidebar/Sidebar.types'
import * as uiActionTypes from '../../Store/UI/UI.types'
import { createActionTypeEvents } from './Analytics.utils'
import authEvents from './Events/Auth.events'
import filtersEvents from './Events/Filters.events'
import ordersEvents from './Events/Orders.events'
import routerEvents from './Events/Router.events'
import envGet from 'Support/Env/Get/EnvGet.support'

const sidebarEvents = createActionTypeEvents(sidebarActionTypes)
const uiEvents = createActionTypeEvents(uiActionTypes)
const REACT_APP_VERSION = envGet({ key: `REACT_APP_VERSION` })
const loginVersionEvents = createActionTypeEvents({
  [`[LOGIN VERSION] v${REACT_APP_VERSION}`]: `[LOGIN VERSION] v${REACT_APP_VERSION}`,
})
/**
 * The analytics event map
 * @param {func} metaDataFunc The meta data function
 * @returns {any} The event map
 */
const eventsMap = [authEvents, routerEvents, filtersEvents, ordersEvents, uiEvents, sidebarEvents, loginVersionEvents]

export default eventsMap
